module.exports = __WEBPACK_EXTERNAL_MODULE_137__;


//////////////////
// WEBPACK FOOTER
// external "resolve-global"
// module id = 137
// module chunks = 0